module.exports = __webpack_public_path__ + "img/Blog-Image@2x.f5f006c3.png";